import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { sentryCatch } from 'src/modules/config/utils/sentryCatch';
import { MODAL_PROFILE_ERROR_CLOSE, MODAL_PROFILE_ERROR_RETRY } from 'src/modules/modals/actions/ModalActions';
import { showNotification } from 'src/modules/notifications/sagas/showNotification';
import { syncProfileForeground } from 'src/modules/profile/sagas/utils/syncProfileForeground';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { GetRequestActionType } from 'src/utils/createActions';
import { call, put } from 'typed-redux-saga';

export function* modalProfileErrorSaga(
  action: GetRequestActionType<typeof MODAL_PROFILE_ERROR_RETRY>,
): SagaIterator<void> {
  const form = action.data;

  try {
    yield* call(logDebug, 'Synchronizing profile...');
    yield* put(MODAL_PROFILE_ERROR_RETRY.pending());

    const synchronized = yield* call(syncProfileForeground, form);
    yield* call(logDebug, 'Synchronizing profile... done');

    yield* put(MODAL_PROFILE_ERROR_RETRY.success(synchronized));
    yield* put(MODAL_PROFILE_ERROR_CLOSE.trigger());
  } catch (error) {
    const wrapped = new RuntimeError('Could not save profile', { form }, NativeError.wrap(error));
    yield* call(logError, 'Synchronizing profile... error', error);
    yield* put(MODAL_PROFILE_ERROR_RETRY.failure(wrapped));

    yield* call(sentryCatch, wrapped);
    yield* call(showNotification, { variant: 'error', type: 'error' });
  }
}
